import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.css'],
    standalone: false
})
export class CalendarComponent implements OnInit {

  token: any;
  id: any;

  dateList: Date[] = [];
  currentMonth: Date = new Date();

  slots: any[] = [];
  doctor: any;

  constructor(public utility: UtilitiesService, private modalService: NgbModal, private api: ApiService, private route: ActivatedRoute, public datepipe: DatePipe) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.id = localStorage.getItem('id');
    this.generateDateList();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let id = params['id'] != null ? params['id'] : null;

      let item = localStorage.getItem('doctor');
      if (item) this.doctor = JSON.parse(item);

      this.getDoctorSlots(id);
    });
  }

  getDoctorSlots(id: any) {
    this.utility.loading = true;
    const sub = this.api.get('schedules/all/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.slots = objects.schedules;
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  generateDateList() {
    const firstDayOfMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), 1);
    const lastDayOfMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 0);
    const totalDays = lastDayOfMonth.getDate();

    for (let i = 0; i < totalDays; i++) {
      const date = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth(), i + 1);
      this.dateList.push(date);
    }
  }

  getThisDaySlots(date: any) {
    let select_date = this.datepipe.transform(date, 'yyyy-MM-dd');
    return this.slots.filter(i => this.datepipe.transform(i.date_time, 'yyyy-MM-dd') === select_date);
  }

  goToNextMonth() {
    this.currentMonth.setMonth(this.currentMonth.getMonth() + 1);
    this.dateList = [];
    this.generateDateList();
  }

  goToPreviousMonth() {
    this.currentMonth.setMonth(this.currentMonth.getMonth() - 1);
    this.dateList = [];
    this.generateDateList();
  }
}
